import logoAb4cus from '@/assets/images/logo_ab4cus.png'
import logo from '@/assets/video/logotipofooter.svg'
import { Logo } from '@/components/molecules/Logo/Logo'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@/components/atoms/Typography/Typography'
import TermsAndPrivacyModal from '@/components/templates/TermsAndPrivacyModal/TermsAndPrivacyModal'

interface FooterProps {
  isError?: boolean
}

const Footer: React.FC<FooterProps> = ({ isError = false }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalTab, setModalTab] = useState<'terms' | 'privacy' | 'accessibility' | 'legal'>('terms')
  
  // Función para manejar el scroll suave
  const handleScroll = (sectionId: string): void => {
    if (isError) {
      navigate('/')
    } else {
      const section = document.getElementById(sectionId)
      if (section != null) {
        section.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  const openTermsModal = () => {
    setModalTab('terms')
    setIsModalOpen(true)
  }

  const openPrivacyModal = () => {
    setModalTab('privacy')
    setIsModalOpen(true)
  }

  const openAccessibilityModal = () => {
    setModalTab('accessibility')
    setIsModalOpen(true)
  }

  const openLegalModal = () => {
    setModalTab('legal')
    setIsModalOpen(true)
  }

  return (
    <footer className='bg-[#F3F6FC] text-white p-2 pt-8 lg:p-8'>
      <div className='container lg:max-w-[1220px] mx-auto grid grid-cols-1 md:grid-cols-4 gap-8'>
        <div className='w-full h-full flex items-center flex-1'>
          <Logo src={logo} alt='Areti Logo' width={280} height={80} />
        </div>
        <div>
          <Typography variant='h6' className='mb-8 text-[#18181B]'>{t('footer.support')}</Typography>
          <ul className='space-y-2 text-[#18181B]'>
            <li>
              <a onClick={() => handleScroll('home')} className='hover:underline cursor-pointer'>
                {t('footer.phone')}
              </a>
            </li>
            <li>
              <a onClick={() => handleScroll('about')} className='hover:underline cursor-pointer'>
                {t('footer.mail')}
              </a>
            </li>
            <li>
              <a onClick={() => handleScroll('services')} className='hover:underline cursor-pointer'>
                {t('footer.address')}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <Typography variant='h6' className='mb-8 text-[#18181B]'>{t('footer.resource')}</Typography>
          <ul className='space-y-2 text-[#18181B]'>
            <li><a href='#' className='hover:underline'>{t('footer.blog')}</a></li>
            <li><a href='#' className='hover:underline'>{t('footer.linkedin')}</a></li>
          </ul>
        </div>
        <div>
          <Typography variant='h6' className='mb-8 text-[#18181B]'>{t('footer.resource')}</Typography>
          <ul className='space-y-2 text-[#18181B]'>
            <li>
              <button 
                onClick={openTermsModal} 
                className='hover:underline text-left'
              >
                {t('footer.terms')}
              </button>
            </li>
            <li>
              <button 
                onClick={openPrivacyModal} 
                className='hover:underline text-left'
              >
                {t('footer.policy')}
              </button>
            </li>
            <li>
              <button 
                onClick={openAccessibilityModal} 
                className='hover:underline text-left'
              >
                {t('footer.accessibility')}
              </button>
            </li>
            <li>
              <button 
                onClick={openLegalModal} 
                className='hover:underline text-left'
              >
                {t('footer.legal')}
              </button>
            </li>
          </ul>
        </div>
			</div>
			<div className='w-full h-[1px] bg-[#636363] mt-8 opacity-20 max-w-[1220px] mx-auto'></div>
      <div className='text-[#18181B] w-full flex items-center flex-col md:flex-row gap-4 justify-center text-center mt-8 pb-8 lg:pb-0 container lg:max-w-[1220px] mx-auto'>
        <Typography variant='p' className='text-sm'>
          © {new Date().getFullYear()} Areti. {t('footer.rights')}
        </Typography>
        <a href='https://www.ab4cus.com/?utm_source=customer&utm_medium=footer&utm_campaign=redirect'><img src={logoAb4cus} alt='Desarrollado por Ab4cus' width={60} /></a>
      </div>

      <TermsAndPrivacyModal 
        showButton={false}
        isOpen={isModalOpen}
        onOpenChange={setIsModalOpen}
        initialTab={modalTab}
      />
    </footer>
  )
}

export default Footer
